import { useQuery } from 'react-query'

import { DeduplicationService } from '../services'

export const useDeduplicationRunGroups = (
  runId: string,
  params: { limit: number; offset: number; terminal?: string; status?: string; q?: string }
) =>
  useQuery(
    ['deduplication-run-groups', runId, params],
    () => DeduplicationService.getRunGroups(runId, params),
    { enabled: !!runId }
  )
